import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Grid, Affix, Drawer } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";

const { Header: AntHeader, Content, Sider } = Layout;

const { useBreakpoint } = Grid;

interface MainProps {
  children: JSX.Element;
  namePage?: string;
  subNamePage?: string;
  showHeader?: boolean;
  footerComponent?: JSX.Element | null;
}

const ProductLayout: FC<MainProps> = ({
  children,
  namePage,
  footerComponent,
}) => {
  const screens = useBreakpoint();
  const sidenavColor = "#1890ff";
  const sidenavType = "#fff";
  const fixed = false;

  const [visible, setVisible] = useState(false);


  let { pathname } = useLocation();
  pathname = pathname.replace("/", "");

  const openDrawer = () => setVisible(!visible);


  return (
    <Layout
      className={`layout-dashboard ${pathname === "profile" ? "layout-profile" : ""
        } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
    >
      <Drawer
        title={false}
        placement="left"
        closable={false}
        onClose={() => setVisible(false)}
        visible={visible}
        key="left"
        width={250}
      >
        <Layout
          className={`layout-dashboard layout-dashboard-rtl}`}
        >
          <Sider
            trigger={null}
            width={250}
            theme="light"
            className={`sider-primary ant-layout-sider-primary ${sidenavType === "#fff" ? "active-route" : ""
              }`}
            style={{ background: sidenavType }}
          >
            <Sidenav color={sidenavColor} />
          </Sider>
        </Layout>
      </Drawer>

      {screens.md && (
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          onCollapse={(collapsed, type) => {
            // console.log(collapsed, type);
            // setResponsive(collapsed);
          }}
          trigger={null}
          width={250}
          theme="light"
          className={`sider-primary ant-layout-sider-primary ${sidenavType === "#fff" ? "active-route" : ""
            }`}
          style={{ background: sidenavType, borderRadius: "12px 12px 0px 0px" }}
        >
          <Sidenav color={sidenavColor} />
        </Sider>
      )}
      <Layout>
        {/* hidden navbar on mobile */}
        {screens.xs ? null : (
          <Affix>
            <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
              <Header name={namePage} onPress={openDrawer} />
            </AntHeader>
          </Affix>
        )}
        <Content className="content-ant">{children}</Content>
        <Affix offsetBottom={0}>
          {footerComponent === null ? null : (
            <AntHeader>{footerComponent}</AntHeader>
          )}
        </Affix>
      </Layout>
    </Layout>
  );
};

export default ProductLayout;
